<template>
    <div class="customeridentity">
  
      <h1>Hämta dina uppgifter</h1>
      <form @submit.prevent="lookup" class="customeridentity__lookup" id="get-customeridentity-with-bankid">
          <button type="submit" class="customeridentity__lookup-submit button button--secondary" :disabled="$root.loading" v-bind:class="{loading : $root.loading}" v-on:click="$root.trackClickEvent('cta_kunduppgifter_steg3')">
            <span class="customeridentity__submit_text">Hämta uppgifter via BankID</span>
            <span class="customeridentity__submit_loader"><img src="@/assets/images/svg-loaders/spinning-circles.svg" width="21" alt="Laddar" /></span>
          </button>
          <span id="customeridentity__auth_message" class="open-BankId-text" v-if="$root.loading"></span>
          <div id="customeridentity__qrcode" class="customeridentity__qrcode" v-if="$root.loading"></div>
      </form>

      <form @submit.prevent="submit">
        <div class="step-nav">
          <button type="submit" class="button button--with-icon step-nav__button" v-on:click="$root.trackClickEvent('cta_kunduppgifter_steg4')">Fortsätt <Arrow /></button>
        </div>
     </form>
    </div>
  </template>
  <script>

 
  export default {
 
    components: {

    },  
    mounted() {
        document.getElementsByClassName('customeridentity')[0].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});

        //document.getElementById('customeridentity__qrcode').innerHTML = this.$root.generateQrCodeImgTag('Test');

      },
    
    data() {
      return {
      }
    },
    methods: {
      getNumberText(txt) {
            if (!txt)
                return '';

            let s = '';

            for (let i = 0; i < txt.length; i++) {
                let c = txt[i];

                if (c >= '0' && c <= '9') {
                    s += c;
                }
            }

            return s;
        },      
      checkValidity(onlyUpdateIfValid) {
      
          if (!onlyUpdateIfValid)
              onlyUpdateIfValid = false;
              
          var r = true;
          
      var elements = document.querySelectorAll('.customeridentity INPUT');
          for (var i = 0; i < elements.length; i++) {
              var el = elements[i];
              
              el.oninput = function (e) {
                  e.target.setCustomValidity('');
              }
              
              var customCheck = true;
              var isRequired = true;
              
              if (el.className.indexOf('notrequired') > 0) {
                  isRequired = false;
              }
              
              if (onlyUpdateIfValid) {
                  if (el.value != '') {
                      el.setCustomValidity('');
                  }
              } else {
                  el.setCustomValidity('');
                  if (isRequired && (el.value == '' || !el.validity.valid || !customCheck)) {
                      //console.log (el);
                      el.setCustomValidity("Fyll i det här fältet.");
                      r = false;
                  }
              }
          }
          
          return r;
      },
      submit() {

        if (!this.checkValidity()) {
          return false;
        }

        if (this.$root.customer == 'new') {
            this.$root.tagSetEditMode('customernew');
        } else {
            this.$root.tagSetEditMode('customerold');
        }

        this.$root.flowString += 'customeridentity';
      },
      parseExtendedPersonLookup(r) {

        let curThis = this;

          // Reset values
          curThis.$root.address = '';
          curThis.$root.location = '';
          curThis.$root.postal_code = curThis.$root.searchPostalCode;
          curThis.$root.email = '';
          curThis.$root.phone = '';
          curThis.$root.customer = 'new';

          curThis.$root.invoice_address = '';
          curThis.$root.invoice_postal_code = '';
          curThis.$root.invoice_location = '';
          
          curThis.$root.possible_properties = [];
          curThis.$root.territory_id = '';
          curThis.$root.construction_id = '735 999';
                  
        this.$root.loading = false;
                  if(r.status==='OK'){

                    this.$root.possible_properties = [];

                    if (r.customer != null && r.customer.meteringPoints != null) {

                      for (let i = 0; i < r.customer.meteringPoints.length; i++) {
                          let cur = r.customer.meteringPoints[i];

                          if (cur.activeContractProductDescription.toLowerCase().indexOf('produktion') >= 0) {
                            continue;
                          }

                          let stopDate = new Date((new Date(cur.activeContractStopDate).getTime() - 24*3600*1000)).toLocaleString().substr(0,10).trim();

                          this.$root.possible_properties.push({
                              id: i,
                              net_areacode: cur.netAreaCode,
                              ean: cur.ean,
                              net_owner: cur.netOwner,
                              contract_description: cur.activeContractProductDescription,
                              contract_startdate: cur.activeContractStartDate,
                              contract_stopdate: stopDate,
                              address: cur.postalAddress,
                              postal_code: cur.postalCode,
                              postal_city: cur.postalCity
                          });
                        }
                    }

                    if (typeof(r.person.givenName) != 'undefined' && r.person.givenName != '') {
                      this.$root.name = r.person.givenName;
                    } else {
                      this.$root.name = r.person.firstName;
                    }
                    
                    this.$root.surname = r.person.lastName;

                    if (r.isCustomer && this.$root.possible_properties.length > 0) {

                      /*
                      if (this.getNumberText(r.customer.postalCode) != this.getNumberText(this.$root.searchPostalCode)) {
                        alert ("Postnumret som kommer upp för denna kunden (" + r.customer.postalCode + ") skiljer sig ifrån vad som är sökt ovan. Var god ändra din sökning ovan för att gå vidare.");
                        return false;
                      }*/
                      
                      this.$root.address = r.customer.address;
                      this.$root.location = r.customer.postalCity;
                      this.$root.postal_code = r.customer.postalCode;
                      this.$root.email = r.customer.email;
                      this.$root.phone = r.customer.phone;
                      this.$root.customerKey = r.customer.customerKey;
                      this.$root.customer = 'old';

                      this.$root.invoice_address = r.customer.address;
                      this.$root.invoice_postal_code = r.customer.postalCode;
                      this.$root.invoice_location = r.customer.postalCity;
                      
                      this.$root.possible_properties.push({
                              id: this.$root.possible_properties.length,
                              net_areacode: '',
                              ean: 'new',
                              net_owner: '',
                              contract_description: '',
                              contract_startdate: '',
                              contract_stopdate: '',
                              address: 'Ny anläggning för postnummer ' + this.$root.searchPostalCode,
                              postal_code: '',
                              postal_city: ''
                          });

                    } else {

                      
                      this.$root.invoice_address = r.person.street;
                      this.$root.invoice_postal_code = r.person.zipCode;
                      this.$root.invoice_location = r.person.city;

                      if (this.getNumberText(r.person.zipCode) != this.getNumberText(this.$root.searchPostalCode)) {
                        alert ("Postnumret enligt folkbokföringen (" + r.person.zipCode + ") skiljer sig ifrån vad som är ifyllt ovan. Om detta är korrekt så fortsätt annars var god ändra din sökning i steg ett för att gå vidare.");
                        return false;
                      }

                      this.$root.address = r.person.street;
                      this.$root.location = r.person.city;
                      this.$root.postal_code = r.person.zipCode;
                      this.$root.customer = 'new';



                    }
                    
                    setTimeout (function () {
                        curThis.submit();
                    }, 100);
                  }else{
                      console.log(r);
                      alert('Det gick ej att hämta uppgifter. Var god fyll i för hand.')
                  }
      },
      extendedPersonLookup() {

        let curThis = this;
        let nonce = this.$root.getCookie('elavtal');

        const headers = new Headers();
              headers.append(
                  "Authorization",
                  nonce
              );

        fetch(this.$root.publicUrl + '/api/extendedperson.php?ssn='+this.$root.personnummer, {
                  method: "GET",
                  headers,
                  cache: "default"
              }).then(r => r.json()).then(r => {
                  this.$root.loading = false;
                  curThis.parseExtendedPersonLookup(r);
              });
      },
      /*
      extendedPersonLoader(callback) {

        let nonce = this.$root.getCookie('elavtal');

        const headers = new Headers();
              headers.append(
                  "Authorization",
                  nonce
              );

        fetch(this.$root.publicUrl + '/api/loadextendedperson.php?ssn='+this.$root.personnummer, {
          method: "GET",
          headers,
          cache: "default"
        }).then(r => r.json()).then(r => {

          if(r.status==='OK'){
            callback(true);
          } else {
            callback(false);
          }
        });
    },
    */
    authSSN (callback) {
        let curThis = this;

        //this.$root.auth.ssn = ssn;

        fetch(this.$root.publicUrl + '/api/bankid.php?api=auth&requestType=' + this.$root.auth.requestType).then(r => r.json()).then(r => {
          if (r != null && r.success) {
              curThis.$root.auth.transactionId = r.transactionId;
              curThis.$root.auth.autoStartToken = r.autoStartToken;
              curThis.$root.auth.step = 2;

              if (curThis.$root.auth.qrCode != r.qrCode) {
                curThis.$root.auth.qrCode = r.qrCode;
                document.getElementById('customeridentity__qrcode').innerHTML = this.$root.generateQrCodeImgTag(curThis.$root.auth.qrCode);
              }

              callback(true);
              //curThis.collect();
            } else {
              curThis.$root.auth.step = 1;
              console.log('error');
              callback(false);
            }
        });

      },
      authCollect (callback) {

        let curThis = this;
        fetch(this.$root.publicUrl + '/api/bankid.php?api=authcollect&transactionId='+this.$root.auth.transactionId+'&requestType=' + this.$root.auth.requestType).then(r => r.json()).then(r => {

              if (curThis.$root.auth.qrCode != r.qrCode) {
                curThis.$root.auth.qrCode = r.qrCode;
                document.getElementById('customeridentity__qrcode').innerHTML = this.$root.generateQrCodeImgTag(curThis.$root.auth.qrCode);
              }

              document.getElementById('customeridentity__auth_message').innerHTML = '<a href="bankid:///?autostarttoken='+curThis.$root.auth.autoStartToken+'&redirect=">Starta BankID säkerhetsprogram på denna enhet</a>';

              var self = curThis;
              switch(r.status.toUpperCase()) {
                  case 'COMPLETE':
                    curThis.$root.auth.step = 3;
                    callback(true, r);
                      break;
                    case 'FAILED':
                      curThis.$root.auth.step = 1;
                      callback(false);
                      break;
                  case 'USER_SIGN':
                      curThis.$root.auth.message = 'Skriv in säkerhetskoden i BankID-programmet.';
                      if (curThis.$root.auth.step < 3) {
                        setTimeout(function() {
                            self.authCollect(callback);
                        }, 200);
                      }
                      break;
                  case "NO_CLIENT":
                  curThis.$root.auth.message = '<a href="bankid:///?autostarttoken='+curThis.$root.auth.autoStartToken+'&redirect=">Starta BankID säkerhetsprogram</a>';
                  callback(false);
                      break;
                  case "USER_CANCEL":
                  curThis.cancel();
                    callback(false);
                      break;
                  default:
                    curThis.$root.auth.collect ++;

                    curThis.$root.auth.message = '<a href="bankid:///?autostarttoken='+curThis.$root.auth.autoStartToken+'&redirect=">Starta BankID säkerhetsprogram på denna enhet</a>';

                      if(curThis.$root.auth.requestType === 'MobileBankID')
                      curThis.$root.auth.message = 'Starta BankID-appen på din mobiltelefon eller surfplatta.';

                      if(curThis.$root.auth.requestType === 'BankID') {
                        curThis.$root.auth.message = 'Försöker starta BankID-programmet.';
                          if(curThis.$root.auth.collect>50) {
                            curThis.$root.auth.message = '<a href="bankid:///?autostarttoken='+curThis.$root.auth.autoStartToken+'&redirect=">Starta BankID säkerhetsprogram</a>';
                          }
                      }

                      if (curThis.$root.auth.step < 3) {
                        setTimeout(function() {
                            self.authCollect(callback);
                        }, 200);
                      }
              }
          });

      },
      lookup() {

        let isTest = !this.$root.isProduction;

            let curThis = this;

            this.$root.feedback.ssn = false; // hide feedback for ssn
            this.$root.loading = true;

            /*if (isTest) {
              curThis.extendedPersonLookup();
              return;
            }*/

            curThis.authSSN(function (retAuth) {
              if (!retAuth) {
                alert('Det gick inte att starta BankID-verifiering för detta personnummer. Försök igen eller fyll i uppgifterna för hand.');
                return false;
              }

                setTimeout(function () {
                    curThis.authCollect(function (ret, retValue) {
                      if (!ret) {
                        alert('Misslyckades att verifiera med BankID. Försök igen senare eller gå vidare och fyll i uppgifterna för hand.')
                        document.getElementById('customeridentity__qrcode').innerHTML = '';
                        document.getElementById('customeridentity__auth_message').innerHTML = '';
                        curThis.$root.loading = false;
                        return false;
                      }

                      curThis.$root.personnummer = retValue.personalNumber;

                      if (!retValue)
                        retValue = null;

                    // Move forward

                    // Reset values
                    curThis.$root.address = '';
                    curThis.$root.location = '';
                    curThis.$root.postal_code = curThis.$root.searchPostalCode;
                    curThis.$root.email = '';
                    curThis.$root.phone = '';
                    curThis.$root.customer = 'new';

                    curThis.$root.invoice_address = '';
                    curThis.$root.invoice_postal_code = '';
                    curThis.$root.invoice_location = '';
                    
                    curThis.$root.possible_properties = [];
                    curThis.$root.territory_id = '';
                    curThis.$root.construction_id = '735 999';
                    
                    //curThis.extendedPersonLookup();
                    curThis.parseExtendedPersonLookup(retValue.persondata);

                  });         
                }, 1000);   



            });


      },
    }
  }
  </script>
  <style lang="scss">
    .uppgifter__anlaggning {
      margin-top: 35px;
      &__hidden {
        padding-top: 20px;
      }
      h3 {
        font-size: 18px;
      }
      &__subtitle {
        display: block;
        font-size: 18px;
        font-weight: bold;
      }
      &__field-wrapper {
        position: relative;
        display: block;
        margin-bottom: rem(16);
      }
      &__field-wrapper .info-circle {
        position: absolute;
        top: 60%;
        right: 5%;      
      }    
      &__field {
        position: absolute;
        opacity: 0;
      }
      &__field-content {
        border: 1px solid $light-border-color;
        border-radius: 3px;
        display: block;
      }
      &__field:focus + &__field-content,
      &__field-content:hover {
        border-color: $dark-border-color;
      }
      &__field:checked + &__field-content {
        border-color: $primary-color;
        border-width: 2px;
      }
      &__field-label {
        display: block;
        @include font-primary;
        font-size: rem(16);
        padding: rem(19);
        position: relative;
        em {
          font-style: normal;
          color: #c00;
        }
      }
      .info-circle {
        position: absolute;
        right: 15px;
        bottom: 7px;
        .tooltip {
          display: none;
        }
        &:hover .tooltip {
          display: block;
          left: -360px;
        }
      }
    }
    .customeridentity {
      &__qrcode {
        display: block;
        clear: both;
        text-align: center;
        width: 100%;
      }
      &__title {
        text-align: center;
        margin: 0 0 rem(30);
        @include font-primary;
        @include media('>lg') {
          font-size: rem(26);
        }
        @include media('<=lg') {
          font-size: rem(22);
          line-height: (36/22);
        }
      }
      &__block {
        margin-bottom: rem(40);
      }
      &__block-title {
        @include font-primary(bold);
        color: $secondary-text-color;
        font-size: rem(18);
        margin: 0 0 rem(15);
      }
      &__field-wrapper {
        margin-bottom: rem(24);
        font-size: rem(16);
        display: block;
        position: relative;
      }
  
      &__field-group {
        @include media('>lg') {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: flex-end;
        }
      }
      &__lookup {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: flex-end;
          .feedback {
              margin-top: -15px;
              margin-bottom: 20px;
        }
      }
          .open-BankId-text {
              font-size: rem(16);
              color: #484848;
              margin-top: -15px;
              margin-bottom: 10px;
              width: 100%;
              text-align: center;
              display: block;
          }
      &__field-group &__field-wrapper {
        @include media('>lg') {
          flex-basis: calc(50% - #{rem(12)});
        }
      }
      &__lookup &__field-wrapper {
        flex-basis: calc(50% - #{rem(12)});
      }
      &__field {
        @include unstyled-text-field;
        display: block;
        width: 100%;
        border: 1px solid $light-border-color;
        padding: #{(13/18)}em;
        &:focus,
        &:hover {
          border-color: $dark-border-color;
        }
        &::placeholder {
          color: $dark-border-color;
        }
      }
      &__field-label {
        @include font-primary;
        color: $secondary-text-color;
        margin: 0 0 rem(6);
        display: block;
        &--title {
          @include font-primary(bold);
          color: $secondary-text-color;
          font-size: rem(18);
          display: block;
          margin: 0 0 rem(9);
        }
        em {
          font-style: normal;
          color: #c00;
        }
      }
      &__lookup-submit {
        @include media('>lg') {
          flex: 1 1;
          margin: 0 0 rem(24) 0;
        }
        @include media('<=lg') {
          /*flex: 1 1;*/
          margin: 0 0 rem(24) 0;
        }
        font-size: rem(16);
        &[disabled], &:hover[disabled]{
          background-color: #fff;
        }
        .customeridentity__submit_text {
          display: block;
        }
        .customeridentity__submit_loader {
          display: none;
        }
        &.loading {
          padding: 9px 0 6px 0;
          .customeridentity__submit_text {
            display: none;
          }
          .customeridentity__submit_loader {
            display: block;
          }
        }
      }
      &__ids {
        margin-bottom: 1rem;
      }
      &__ids-text {
        @include font-primary(roman);
        font-size: rem(13);
        padding: rem(16);
        background-color: $light-bg-color;
        color: $secondary-text-color;
        text-align: center;
        border-radius: 4px;
        display: block;
        width: 100%;
        margin: 25px 0 10px 0;
      }
    }
  
  </style>